// loadgin.vue
<template>
  <van-popup
    :close-on-click-overlay="false"
    v-model="show"
    style="background-color:transparent"
  >
    <div class="loadingWrap">
      <van-loading v-if="show" type="spinner" />
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "loading",
  data() {
    return {
      show: false
    };
  }
};
</script>

<style lang="less" scoped>
.loadingWrap /deep/.van-popup {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue